import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export interface WebSearchResult {
  search_type: string;
  query_time: string;
  content: string;
  citations: Citation[];
  results: SearchResultItem[];
  total_results: number;
  error?: string;
}

export interface Citation {
  url: string;
  title: string;
  start_index: number;
  end_index: number;
}

export interface SearchResultItem {
  title: string;
  url: string;
  summary: string;
  legal_references: string[];
  type: string;
  relevance_score: number;
}

class WebSearchService {
  private getRequestConfig() {
    return {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true // Include HTTP-only cookies
    };
  }

  async searchStatutes(query: string): Promise<WebSearchResult> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/web-search/statutes?query=${encodeURIComponent(query)}`,
        {},
        this.getRequestConfig()
      );
      return response.data;
    } catch (error) {
      console.error('Statute search failed:', error);
      throw error;
    }
  }

  async searchCourtDecisions(query: string): Promise<WebSearchResult> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/web-search/court-decisions?query=${encodeURIComponent(query)}`,
        {},
        this.getRequestConfig()
      );
      return response.data;
    } catch (error) {
      console.error('Court decision search failed:', error);
      throw error;
    }
  }

  async searchEULaw(query: string): Promise<WebSearchResult> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/web-search/eu-law?query=${encodeURIComponent(query)}`,
        {},
        this.getRequestConfig()
      );
      return response.data;
    } catch (error) {
      console.error('EU law search failed:', error);
      throw error;
    }
  }

  async searchLegalNews(query: string): Promise<WebSearchResult> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/web-search/news?query=${encodeURIComponent(query)}`,
        {},
        this.getRequestConfig()
      );
      return response.data;
    } catch (error) {
      console.error('Legal news search failed:', error);
      throw error;
    }
  }

  async searchComprehensive(query: string): Promise<WebSearchResult> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/web-search/comprehensive?query=${encodeURIComponent(query)}`,
        {},
        this.getRequestConfig()
      );
      return response.data;
    } catch (error) {
      console.error('Comprehensive search failed:', error);
      throw error;
    }
  }
}

export const webSearchService = new WebSearchService();